import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const AGAINST_SEARCH = 'AGAINST_SEARCH' // 违规数据查询
const AGAINST_SUMMARY = 'AGAINST_SUMMARY' // 违规数据统计
const DASHBOARD_SUMMARY = 'DASHBOARD_SUMMARY' // 首页违规数据统计
const AGAINST_GET_DETAIL = 'AGAINST_GET_DETAIL' // 违规备注详情
const REMARK_DELETE = 'REMARK_DELETE' // 删除违规明细备注
const REMARK_ADD = 'REMARK_ADD' // 添加违规明细备注
const POST_DETAIL = 'POST_DETAIL' // 新增违规明细
const UPDATE_DETAILS = 'UPDATE_DETAILS' // 批量标记
const UPDATE_TO_WHITE = 'UPDATE_TO_WHITE' // 黑词加白
const GET_CONTENT_LIST = 'GET_CONTENT_LIST' // 内容审核列表



const defaultState = Immutable.fromJS({
  againstList: {
    list: [],
    total: 0
  },
  againstDetailList: {
    list: [],
    total: 0
  },
  contentList: {
    list: [],
    total: 0
  }
})

export const statisticAction = createActions({
  AGAINST_SEARCH: async params => {
    const result = await fetch.post(`/violation/searchDetails`, params)
    return result
  },
  AGAINST_SUMMARY: async params => {
    const result = await fetch.post(`/violation/getSummary`, params)
    return result
  },
  DASHBOARD_SUMMARY: async params => {
    const result = await fetch.post(`/violation/getDashBordSummary`, params)
    return result
  },
  AGAINST_GET_DETAIL: async params => {
    const result = await fetch.post(`/violation/getDetail`, params)
    return result
  },
  REMARK_DELETE: async params => {
    const result = await fetch.post(`/violation/deleteDetailRemark`, params)
    return result
  },
  REMARK_ADD: async params => {
    const result = await fetch.post(`/violation/appendDetailRemarks`, params)
    return result
  },
  REMARK_UPDATE: async params => {
    const result = await fetch.post(`/violation/updateDetailTypes`, params)
    return result
  },
  POST_DETAIL: async params => {
    const result = await fetch.post(`/violation/postDetail`, params)
    return result
  },
  UPDATE_DETAILS: async params => {
    const result = await fetch.post(`/violation/updateDetails`, params)
    return result
  },
  UPDATE_DETAIL_STATUS: async params => {
    const result = await fetch.post(`/violation/updateDetailStatus`, params)
    return result
  },
  UPDATE_TO_WHITE: async params => {
    const result = await fetch.post(`/violation/updateUserWhiteWord`, params)
    return result
  },
  POST_MONITOR: async params => {
    const result = await fetch.post(`/violation/postUserMonitors`, params)
    return result
  },
  GET_CONTENT_LIST: async params => {
    const result = await fetch.post(`/increase/sms/search`, params)
    return result
  }
})

const reducer = handleActions(
  {
    [AGAINST_SEARCH]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'againstList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [AGAINST_GET_DETAIL]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload.auditInformation
      curState = curState.set(
        'againstDetailList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [GET_CONTENT_LIST]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'contentList',
        new Map({
          list: new List(records || []),
          total: totalCount
        })
      )
      return curState
    }
  },
  defaultState
)

export default reducer
